import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { financeApi } from "../../../finance-api-client";
import { queryKeys } from "../../query-keys";

export function useCreditNotes(clubId: string | null, invoiceId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.creditNotes(clubId ?? "", invoiceId ?? ""),
		queryFn: () => financeApi.invoices.creditNotes.list(clubId!, invoiceId!),
		enabled: !!clubId && !!invoiceId,
	});
}

export function useCreateCreditNote(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({
			invoiceId,
			data,
		}: {
			invoiceId: string;
			data: { reason: string; amount_cents: number; is_refund: boolean };
		}) => financeApi.invoices.creditNotes.create(clubId, invoiceId, data),
		onSuccess: (_, { invoiceId }) => {
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.creditNotes(clubId, invoiceId),
			});
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.invoiceDetail(clubId, invoiceId),
			});
		},
	});
}
